<template>
  <component
    :is="loading ? 'div' : 'h4'"
    class="truncate font-semibold"
    :class="small ? 'text-sm' : 'text-xl'"
    data-id="card-name"
  >
    <template v-if="loading">
      <RedesignTextLoading class="w-1/2 min-w-[100px]" />
    </template>
    <template v-else-if="accom && url">
      <a :href="url" target="_blank">{{ title }}</a>
    </template>
    <template v-else>{{ title }}</template>
  </component>
</template>

<script setup lang="ts">
const props = defineProps<{
  accom?: ResultDocument
  small?: boolean
  loading?: boolean
  url?: string
}>()

const { t } = useI18n()

const title = computed(
  () =>
    props.accom &&
    [
      t(`www.components.hitbox.Title.type.${props.accom.type}`),
      props.accom.name,
    ].join(' '),
)
</script>
